const ApproverScreenReducer = (state = {}, action) => {
    switch (action.type) {
        case "PendingApprovalCountSuccess":
            return Object.assign({}, state, {
                ApprovalCount: action.data,
            });
            break;
            case "PendingShipCountSuccess":
                return Object.assign({}, state, {
                    PendingShipCount: action.data,
                });
                break;

        case "PendingApprovalCountFailure":
            return Object.assign({}, state, {
                e: action.data,
            });
            break;
        case "PendingApprovalListSuccess":
            return Object.assign({}, state, {
                PendingApprovals: action.data,
            });
            break;
        case "PendingApprovalListFailure":
            return Object.assign({}, state, {
                e: action.data,
            });
            break;
        case "PendingApprovalDetailsSuccess":
            return Object.assign({}, state, {
                ApprovalDetails: action.data,
            });
            break;
        case "PendingApprovalDetailsFailure":
            return Object.assign({}, state, {
                e: action.data,
            });
            break;
        case "PendingEquipmentDetailsSuccess":
            return Object.assign({}, state, {
                EquipmentDetails: action.data,
            });
            break;
        case "PendingEquipmentDetailsfailure":
            return Object.assign({}, state, {
                e: action.data,
            });
            break;
        case "fileUrl":
            return Object.assign({}, state, {
                fileUrl: action.data,
            });
            break;
        case "equipementData":
            return Object.assign({}, state, {
                EquipmentData: action.data,
            });
            break;
        case "serviceImages-1 yearly":
            return Object.assign({}, state, {
                Yearly1: action.data,
            });
            break;
        case "serviceImages-2 yearly":
            return Object.assign({}, state, {
                Yearly2: action.data,
            });
            break;
        case "serviceImages-3 yearly":
            return Object.assign({}, state, {
                Yearly3: action.data,
            });
            break;
        case "serviceImages-5 yearly":
            return Object.assign({}, state, {
                Yearly5: action.data,
            });
            break;
        case "serviceImages-10 yearly":
            return Object.assign({}, state, {
                Yearly10: action.data,
            });
            break;
        case "LoadedSuccess":
            return Object.assign({}, state, {
                isLoaded: action.data,
            });
            break;
        default: {
            return state;
        }
    }
}
export default ApproverScreenReducer;